import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiUrl: 'https://admin.skillers.hu',
    // apiUrl: 'https://beta-admin.skillers.hu',
    // apiUrl: 'https://skillers-api.test',
    // apiUrl: 'http://192.168.10.10:8000',
    eEgyetemLoginUrl: 'https://www.e-egyetem.hu/',
    SAPBuyerLink:
      'https://skillersnyelviskola.hu/skillers---premium-csomagok-rendelese-.html',
    currentUser: null,
    isLoggedIn: null,
    isFreeLesson: null,
    reloadSite: false,
    token: null,
    auth_error: null,
    reg_error: null,
    registeredUser: null,
    lastQuestionState: false,
    lastQuestion: 0,
    courseId: 0,
    subscriptionId: 0,
    lastLingronId: null,
    lastMiniLingronId: null,
    lastLingron: false,
    lingronCounter: 0,
    stepCounter: 0,
    progressIndicator: 0,
    maxLingron: 0,
    currentLessonId: null,
    isApp: false,
    freeLessonRedirectUrl: '',
    fromStepfield: false,
    earnedScores: 0,
    goodAnswers: 0,
    fromLingron: false,
    incorrectAnswers: []
  },
  getters: {
    getFromStepfield(state) {
      return state.fromStepfield;
    },
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    isFreeLesson(state) {
      return state.isFreeLesson;
    },
    isFreeLessonRedirectUrl(state) {
      return state.freeLessonRedirectUrl;
    },
    currentUser(state) {
      state.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return state.currentUser;
    },
    user(state) {
      state.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return state.currentUser;
    },
    currentLessonId(state) {
      return state.currentLessonId;
    },
    getCourseId(state) {
      return state.courseId;
    },
    courseId(state) {
      return state.courseId;
    },
    fromLingron(state) {
      return state.fromLingron;
    },
    getSubscriptionId(state) {
      return state.subscriptionId;
    },
    getApiUrl(state) {
      return state.apiUrl;
    },
    apiUrl(state) {
      return state.apiUrl;
    },
    getEEgyetemLoginUrl(state) {
      return state.eEgyetemLoginUrl;
    },
    getSAPBuyerLink(state) {
      return state.SAPBuyerLink;
    },
    getToken(state) {
      state.token = localStorage.getItem('token');
      return state.token;
    },
    token(state) {
      state.token = localStorage.getItem('token');
      return state.token;
    },
    lastLingron(state) {
      return state.lastLingron;
    },
    getLastQuestionState(state) {
      return state.lastQuestionState;
    },
    getLastQuestion(state) {
      return state.lastQuestion;
    },
    lastLingronId(state) {
      return state.lastLingronId;
    },
    lastMiniLingronId(state) {
      return state.lastMiniLingronId;
    },
    earnedScores(state) {
      return state.earnedScores;
    },
    goodAnswers(state) {
      return state.goodAnswers;
    },
    getStepCounter(state) {
      return state.stepCounter;
    },
    getLingronCounter(state) {
      return state.lingronCounter;
    },
    getProgressIndicator(state) {
      return state.progressIndicator;
    },
    getMaxLingron(state) {
      return state.maxLingron;
    },
    getIsAppState(state) {
      return state.isApp;
    },
    reloadSiteState(state) {
      return state.reloadSite;
    },
    incorrectAnswers(state) {
      return state.incorrectAnswers;
    }
  },
  mutations: {
    login(state) {
      state.auth_error = null;
    },
    loginSuccess(state, payload) {
      state.auth_error = null;
      state.isLoggedin = payload.isLoggedIn;
      state.currentUser = payload.currentUser;
      state.token = payload.token;
      localStorage.setItem('token', payload.token);
      localStorage.setItem('currentUser', JSON.stringify(payload.currentUser));
    },
    loginFailed(state, payload) {
      state.loading = false;
      state.auth_error = payload.error;
    },
    logout(state) {
      state.isLoggedin = false;
      state.currentUser = null;
      state.token = null;
      localStorage.setItem('token', null);
      localStorage.setItem('currentUser', null);
    },
    refreshToken(state, payload) {
      state.token = payload.token;
      localStorage.setItem('token', payload.token);
      state.isLoggedIn = payload.isLoggedIn;
      state.currentUser = payload.currentUser;
      localStorage.setItem('currentUser', JSON.stringify(payload.currentUser));
    },
    updateLastQuestionState(state, payload) {
      state.lastQuestionState = payload.lastQuestionState;
    },
    updateLastQuestion(state, payload) {
      state.lastQuestion = payload.lastQuestionId;
    },
    updateLastLingronId(state, payload) {
      state.lastLingronId = payload.lastLingronId;
    },
    updateLastMiniLingronId(state, payload) {
      state.lastMiniLingronId = payload.lastMiniLingronId;
    },
    updateLastLingron(state, payload) {
      state.lastLingron = payload.lastLingron;
    },
    updateStepCounter(state, payload) {
      state.stepCounter = payload.stepCounter;
    },
    updateLingronCounter(state, payload) {
      state.lingronCounter = payload.lingronCounter;
    },
    updateProgressIndicator(state, payload) {
      state.progressIndicator = payload.progressIndicator;
    },
    updateEarnedScores(state, payload) {
      state.earnedScores = payload.earnedScores;
    },
    updateGoodAnswers(state, payload) {
      state.goodAnswers = payload.goodAnswers;
    },
    updateFromLingron(state, payload) {
      state.fromLingron = payload.fromLingron;
    },
    setMaxLingron(state, payload) {
      state.maxLingron = payload.maxLingron;
    },
    setCurrentLessonId(state, payload) {
      state.currentLessonId = payload.currentLessonId;
    },
    setIsAppState(state, payload) {
      state.isApp = payload.isApp;
    },
    setIsFreeLesson(state, payload) {
      state.isFreeLesson = payload.isFreeLesson;
      state.freeLessonRedirectUrl = payload.freeLessonRedirectUrl;
    },
    setCourseId(state, payload) {
      state.courseId = payload.courseId;
    },
    setSubscriptionId(state, payload) {
      state.subscriptionId = payload.subscriptionId;
    },
    setFromStepfield(state, payload) {
      state.fromStepfield = payload.fromStepfield;
    },
    goodAnswer(state) {
      state.earnedScores += 1;
      state.goodAnswers += 1;
    },
    resetPointsAndAnswers(state) {
      state.earnedScores = 0;
      state.goodAnswers = 0;
    },
    setReloadSite(state, payload) {
      state.reloadSite = payload.reloadSite;
    },
    addItemIncorrectAnswer(state, payload) {
      state.incorrectAnswers.push(payload);
    },
    removeItemIncorrectAnswer(state, payload) {
      let searchedIndex = '';

      //Find the index
      state.incorrectAnswers.forEach((el, index) => {
        if (el.id === payload.id) {
          searchedIndex = index;
        }
      });

      //Remove from state array
      if (searchedIndex !== -1) {
        state.incorrectAnswers.splice(searchedIndex, 1);
      }
    },
    emptyIncorrectAnswers(state) {
      state.incorrectAnswers = [];
    }
  },
  actions: {
    login(context) {
      context.commit('login');
    },
    goodAnswerEarned({ commit }) {
      commit('goodAnswer');
    },
    resetCounters({ commit }) {
      commit('resetPointsAndAnswers');
    }
  }
});
